export interface PillarArticle {
  slug: string;
  icon: string;
  image: string;
}

export const pillarArticles: PillarArticle[] = [
  {
    slug: 'usfans-shopping-guide',
    icon: 'ri-shopping-bag-3-line',
    image: 'https://readdy.ai/api/search-image?query=Bright%20modern%20online%20shopping%20concept%20with%20a%20smartphone%20and%20two%20kraft%20shopping%20bags%20on%20a%20clean%20oak%20desk%2C%20soft%20natural%20light%2C%20airy%20western%20editorial%20aesthetic%2C%20minimal%20composition%2C%20high%20detail&width=800&height=500&seq=guide-shopping-01&orientation=landscape',
  },
  {
    slug: 'usfans-spreadsheet-guide',
    icon: 'ri-table-line',
    image: 'https://readdy.ai/api/search-image?query=Clean%20modern%20laptop%20displaying%20an%20organized%20colorful%20spreadsheet%20table%20on%20a%20bright%20minimalist%20desk%20with%20a%20small%20green%20plant%2C%20soft%20natural%20light%2C%20fresh%20western%20editorial%20style%2C%20high%20detail&width=800&height=500&seq=guide-spreadsheet-01&orientation=landscape',
  },
  {
    slug: 'usfans-review',
    icon: 'ri-star-line',
    image: 'https://readdy.ai/api/search-image?query=Minimalist%20five%20star%20rating%20concept%20with%20a%20small%20notebook%20and%20a%20gold%20pen%20on%20a%20soft%20cream%20desk%2C%20clean%20editorial%20photography%2C%20soft%20natural%20light%2C%20modern%20western%20aesthetic%2C%20high%20detail&width=800&height=500&seq=guide-review-01&orientation=landscape',
  },
  {
    slug: 'usfans-shipping-cost',
    icon: 'ri-truck-line',
    image: 'https://readdy.ai/api/search-image?query=Neatly%20wrapped%20kraft%20cardboard%20packages%20with%20a%20small%20shipping%20label%20on%20a%20bright%20neutral%20table%2C%20minimalist%20logistics%20photography%2C%20soft%20natural%20light%2C%20clean%20western%20editorial%20style%2C%20high%20detail&width=800&height=500&seq=guide-shipping-01&orientation=landscape',
  },
  {
    slug: 'usfans-coupon',
    icon: 'ri-coupon-3-line',
    image: 'https://readdy.ai/api/search-image?query=Scissors%20and%20colorful%20discount%20coupon%20tags%20arranged%20neatly%20on%20a%20soft%20cream%20surface%2C%20minimalist%20savings%20concept%20photography%2C%20soft%20natural%20light%2C%20fresh%20western%20aesthetic%2C%20high%20detail&width=800&height=500&seq=guide-coupon-01&orientation=landscape',
  },
  {
    slug: 'usfans-discount-code',
    icon: 'ri-price-tag-3-line',
    image: 'https://readdy.ai/api/search-image?query=Smartphone%20showing%20a%20simple%20discount%20code%20input%20on%20screen%20beside%20a%20small%20wrapped%20gift%20box%20on%20a%20clean%20desk%2C%20minimalist%20promo%20concept%2C%20soft%20natural%20light%2C%20modern%20western%20style%2C%20high%20detail&width=800&height=500&seq=guide-discount-01&orientation=landscape',
  },
  {
    slug: 'usfans-warehouse',
    icon: 'ri-building-2-line',
    image: 'https://readdy.ai/api/search-image?query=Bright%20organized%20warehouse%20aisle%20with%20neatly%20stacked%20cardboard%20boxes%20on%20metal%20shelves%2C%20clean%20logistics%20photography%2C%20soft%20even%20lighting%2C%20modern%20western%20aesthetic%2C%20high%20detail&width=800&height=500&seq=guide-warehouse-01&orientation=landscape',
  },
  {
    slug: 'is-usfans-legit',
    icon: 'ri-shield-check-line',
    image: 'https://readdy.ai/api/search-image?query=Minimalist%20trust%20concept%20with%20a%20small%20shield%20badge%20and%20a%20metal%20key%20on%20a%20soft%20cream%20desk%2C%20clean%20editorial%20photography%2C%20soft%20natural%20light%2C%20modern%20western%20aesthetic%2C%20high%20detail&width=800&height=500&seq=guide-legit-01&orientation=landscape',
  },
  {
    slug: 'usfans-safety',
    icon: 'ri-lock-line',
    image: 'https://readdy.ai/api/search-image?query=Minimalist%20security%20concept%20with%20a%20metal%20padlock%20and%20a%20simple%20password%20notebook%20on%20a%20clean%20neutral%20desk%2C%20soft%20natural%20light%2C%20modern%20western%20editorial%20style%2C%20high%20detail&width=800&height=500&seq=guide-safety-01&orientation=landscape',
  },
  {
    slug: 'usfans-privacy',
    icon: 'ri-shield-keyhole-line',
    image: 'https://readdy.ai/api/search-image?query=Minimalist%20privacy%20concept%20with%20softly%20closed%20curtains%20and%20a%20small%20lock%20key%20on%20a%20neutral%20surface%2C%20clean%20editorial%20photography%2C%20soft%20natural%20light%2C%20modern%20western%20aesthetic%2C%20high%20detail&width=800&height=500&seq=guide-privacy-01&orientation=landscape',
  },
];